import { buildService } from './decorated-service';

const api = buildService(`nasu-svc/service/reference/states`);

export const getStatesList = async (): Promise<any> => api.index();

export default api;
